import { toXlsxData, toXlsxColumns } from 'core/component/xlsx-utils-excel'

export const getPlantXLSX = (data, headers) => {
  const columns = toXlsxColumns(headers)
  const ed = toXlsxData(data, headers)
  const worksheets = [
    {
      name: 'Plant',
      columns,
      data: ed,
      metaInfo: [],
    },
  ]
  return worksheets
}

export const getInverterGroupXLSX = (data, headers) => {
  const columns = toXlsxColumns(headers)
  const ed = toXlsxData(data, headers)
  const worksheets = [
    {
      name: 'Group',
      columns,
      data: ed,
      metaInfo: [],
    },
  ]
  return worksheets
}

export const getEventListXLSX = (data, headers) => {
  const columns = toXlsxColumns(headers)
  const ed = toXlsxData(data, headers)
  const worksheets = [
    {
      name: 'Event',
      columns,
      data: ed,
      metaInfo: [],
    },
  ]
  return worksheets
}

export const getInverterGroupPerformanceXLSX = (data, headers) => {
  const columns = toXlsxColumns(headers)
  const ed = toXlsxData(data, headers)
  const worksheets = [
    {
      name: 'Group Performance',
      columns,
      data: ed,
      metaInfo: [],
    },
  ]
  return worksheets
}

//   getEnergyStoragePerformanceXLSX

export const getEnergyStoragePerformanceXLSX = (data, headers) => {
  const columns = toXlsxColumns(headers)
  const ed = toXlsxData(data, headers)
  const worksheets = [
    {
      name: 'Storage Performance',
      columns,
      data: ed,
      metaInfo: [],
    },
  ]
  return worksheets
}

export const getEnergyStorageXLSX = (data, headers) => {
  const columns = toXlsxColumns(headers)
  const ed = toXlsxData(data, headers)
  const worksheets = [
    {
      name: 'Storage',
      columns,
      data: ed,
      metaInfo: [],
    },
  ]
  return worksheets
}

export const getInverterEventGroupPerformanceXLSX = (
  data1,
  headers1,
  data2,
  headers2
) => {
  const columns1 = toXlsxColumns(headers1)
  const ed1 = toXlsxData(data1, headers1)
  const columns2 = toXlsxColumns(headers2)
  const ed2 = toXlsxData(data2, headers2)

  const worksheets = [
    {
      name: 'Event',
      columns: columns2,
      data: ed2,
      metaInfo: [],
    },
    {
      name: 'Inverter Group Performance',
      columns: columns1,
      data: ed1,
      metaInfo: [],
    },
  ]
  return worksheets
}
